'use strict';
var escapeRegExp, initRegExp, normalizeQuery, regexp, replacements;

replacements = {};

regexp = '';

escapeRegExp = function(str) {
  return str.replace(/([-.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
};

initRegExp = function(charMap) {
  var invertedMap, reg;
  reg = '';
  invertedMap = Object.entries(charMap).reduce(function(collection, arg) {
    var char, i, key, len, val;
    key = arg[0], val = arg[1];
    reg += val;
    for (i = 0, len = val.length; i < len; i++) {
      char = val[i];
      collection[char] = key;
    }
    return collection;
  }, {});
  return {
    regexp: new RegExp('[' + escapeRegExp(reg) + ']', 'g'),
    replacements: invertedMap
  };
};

normalizeQuery = function(s) {
  var charMap, ref;
  if (typeof s !== 'string') {
    return '';
  }
  if (!regexp) {
    charMap = window.Groupon.LS.data.charMapping || {};
    ref = initRegExp(charMap), regexp = ref.regexp, replacements = ref.replacements;
  }
  s = s.trim().replace(regexp, function(c) {
    return replacements[c];
  });
  return s.toLowerCase();
};

module.exports = {
  initRegExp: initRegExp,
  escapeRegExp: escapeRegExp,
  normalizeQuery: normalizeQuery
};

